import { Injectable } from '@angular/core';
import { DocumentType } from '../../../shared/data-access/models/document-type';

@Injectable({
  providedIn: 'root',
})
export class FileUtilsService {
  public getMimeType(fileExtension?: string): string {
    switch (fileExtension) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      default:
        return 'application/octet-stream';
    }
  }

  public getDocumentType(fileExtension?: string): DocumentType {
    switch (fileExtension) {
      case 'pdf':
        return DocumentType.Pdf;
      case 'doc':
      case 'docx':
        return DocumentType.Word;
      case 'xls':
      case 'xlsx':
        return DocumentType.Excel;
      default:
        return DocumentType.Pdf;
    }
  }
}
